<template>
    <div ref="page" class="page" v-show="authed" style="overflow:hidden">
        <template v-if="styleTemplate == 1">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu vertical-center">
                <div class="menu-item" @click="jumpTo('introduction')">
                    <img src="../assets/img/v2_ptdn19.png"/>
                    <div>诊所介绍</div>
                </div>
                <div class="menu-item" @click="jumpTo('doctorGroup')">
                    <img src="../assets/img/v2_ptdn3q.png"/>
                    <div>医师团队</div>
                </div>
                <div class="menu-item" @click="jumpTo('treatment')">
                    <img style="width:40px;height:40px;margin:5px;" src="../assets/img/v2_ptdn6e.png"/>
                    <div>诊疗项目</div>
                </div>
                <div class="menu-item" @click="jumpTo('activities')">
                    <img src="../assets/img/v2_ptdn8o.png"/>
                    <div>诊所活动</div>
                </div>
                <div class="menu-item" @click="jumpTo('encyclopedia')">
                    <img src="../assets/img/v2_ptdn9p.png"/>
                    <div>口腔百科</div>
                </div>
                <div style="visibility: hidden" class="menu-item" @click="jumpTo('officeCenter')">
                    <img src="../assets/img/info_query.png"/>
                    <div>我要咨询</div>
                </div>
            </div>
        </template>
        <div class="template2" v-if="styleTemplate ==2">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu space-between" style="background: transparent">
                <div class="menu-item" @click="jumpTo('introduction')">
                    <img src="../assets/img/v2_ptdn19.png"/>
                    <div>诊所介绍</div>
                </div>
                <div class="menu-item" @click="jumpTo('doctorGroup')">
                    <img src="../assets/img/v2_ptdn3q.png"/>
                    <div>医师团队</div>
                </div>
                <div class="menu-item" @click="jumpTo('treatment')">
                    <img style="width:40px;height:40px;margin:5px;" src="../assets/img/v2_ptdn6e.png"/>
                    <div>诊疗项目</div>
                </div>
            </div>
            <div class="menu space-between" style="background: transparent">
                <div class="menu-item" @click="jumpTo('activities')">
                    <img src="../assets/img/v2_ptdn8o.png"/>
                    <div>诊所活动</div>
                </div>
                <div class="menu-item" @click="jumpTo('encyclopedia')">
                    <img src="../assets/img/v2_ptdn9p.png"/>
                    <div>口腔百科</div>
                </div>
                <div style="visibility: hidden" class="menu-item" @click="jumpTo('officeCenter')">
                    <img src="../assets/img/info_query.png"/>
                    <div>我要咨询</div>
                </div>
            </div>
        </div>
        <div :class="'template'+styleTemplate" v-if="styleTemplate ==3">
            <div style="background: white">
                <div class="swipe-style2" :style="'height:'+height+'px'" v-show="infoLoaded">
                    <mt-swipe :auto="10000">
                        <mt-swipe-item class="banner-1">
                            <img ref="img" src="../assets/img/home_bg.jpg"/>
                        </mt-swipe-item>
                        <mt-swipe-item class="banner-1">
                            <img src="../assets/img/home_bg.jpg"/>
                        </mt-swipe-item>
                    </mt-swipe>
                </div>
                <div class="menu space-between" style="background: transparent;padding: 0 10px">
                    <div class="menu-item" @click="jumpTo('introduction')">
                        <img src="../assets/img/introduction.png"/>
                        <div>诊所介绍</div>
                    </div>
                    <div class="menu-item" @click="jumpTo('doctorGroup')">
                        <img src="../assets/img/persion.png"/>
                        <div>医师团队</div>
                    </div>
                    <div class="menu-item" @click="jumpTo('treatment')">
                        <img src="../assets/img/search.png"/>
                        <div>诊疗项目</div>
                    </div>
                </div>
                <div class="menu space-between" style="background: transparent;padding: 0 10px 20px 10px">
                    <div class="menu-item" @click="jumpTo('activities')">
                        <img src="../assets/img/position.png"/>
                        <div>诊所活动</div>
                    </div>
                    <div class="menu-item" @click="jumpTo('encyclopedia')">
                        <img class="circle-outfield" src="../assets/img/tooth.png"/>
                        <div>口腔百科</div>
                    </div>
                    <div style="visibility: hidden" class="menu-item" @click="jumpTo('officeCenter')">
                        <img src="../assets/img/info_query.png"/>
                        <div>我要咨询</div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="'template'+styleTemplate" v-if="styleTemplate ==4">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu">
                <div class="vertical-center">
                    <div class="padding-left-10 padding-to-10" style="width: 50%;box-sizing: border-box">
                        <div class="card-type-1" @click="jumpTo('introduction')">
                            <div class="circle-1">
                                <img style="width: 24px;height: 24px;margin-top: 9px" src="../assets/img/hospital.png"/>
                            </div>
                            <div style="color:#80e0d9;font-size: 18px;margin-top: 20px">诊所介绍</div>
                        </div>
                    </div>
                    <div class="padding-left-10 padding-to-10 padding-right-10"
                         style="width: 50%;box-sizing: border-box">
                        <div>
                            <div class="card-type-2 card-color-1 vertical-center" @click="jumpTo('doctorGroup')">
                                <div class="circle-2">
                                    <img style="width: 24px;height: 24px;margin-top: 7px"
                                         src="../assets/img/doctor.png"/>
                                </div>
                                <div style="margin-left: 10px;font-size: 14px">医师团队</div>
                            </div>
                            <div class="card-type-2 card-color-2 vertical-center" @click="jumpTo('treatment')"
                                 style="margin-top: 10px">
                                <div class="circle-3">
                                    <img style="width: 20px;height: 20px;margin-top: 10px"
                                         src="../assets/img/project.png"/>
                                </div>
                                <div style="margin-left: 10px;font-size: 14px">诊疗项目</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 10px" class="vertical-center">
                    <div class="padding-left-10 padding-to-10" style="width: 50%;box-sizing: border-box">
                        <div @click="jumpTo('activities')" class="card-type-2 card-color-1 vertical-center">
                            <div class="circle-2">
                                <img style="width: 24px;height: 24px;margin-top: 7px" src="../assets/img/activity.png"/>
                            </div>
                            <div style="margin-left: 10px;font-size: 14px">诊所活动</div>
                        </div>
                    </div>
                    <div class="padding-left-10 padding-to-10 padding-right-10"
                         style="width: 50%;box-sizing: border-box">
                        <div @click="jumpTo('encyclopedia')" class="card-type-2 card-color-3 vertical-center">
                            <div class="circle-1 text-center" style="width: 40px;height: 40px;">
                                <img style="width: 24px;height: 24px;margin-top: 7px;display: inline-block"
                                     src="../assets/img/tooth.png"/>
                            </div>
                            <div style="margin-left: 10px;font-size: 14px">口腔百科</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="'template'+styleTemplate" v-if="styleTemplate ==5" style="height: 100%;background: white">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu vertical-center">
                <div class="menu-item-group" @click="jumpTo('introduction')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/doctor_2.jpg"/>
                        <div>诊所介绍</div>
                    </div>
                    <img src="../assets/img/wave_1.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('doctorGroup')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/doctor_3.jpg"/>
                        <div>医师团队</div>
                    </div>
                    <img src="../assets/img/wave_2.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('treatment')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/treatment_1.jpg"/>
                        <div>诊疗项目</div>
                    </div>
                    <img src="../assets/img/wave_2.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('activities')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/phone_1.jpg"/>
                        <div>诊所活动</div>
                    </div>
                    <img src="../assets/img/wave_1.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('encyclopedia')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/baike_1.jpg"/>
                        <div>口腔百科</div>
                    </div>
                    <img src="../assets/img/wave_1.jpg"/>
                </div>
            </div>
        </div>

        <div :class="'template'+styleTemplate" v-if="styleTemplate ==6" style="height: 100%">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu border-layout-bottom" :style="'top:'+height+'px;margin-top:6px;background:transparent'">
                <div class="space-between">
                    <div class="selector" style="flex:1" @click="jumpTo('introduction')">
                        <img src="../assets/img/doctor_2.jpg"/>
                        <div>诊所介绍</div>
                    </div>
                    <div class="selector" style="flex:1;margin-left: 1px" @click="jumpTo('doctorGroup')">
                        <img src="../assets/img/doctor_3.jpg"/>
                        <div>医师团队</div>
                    </div>
                </div>
                <div class="space-between" style="margin-top: 1px">
                    <div class="selector" style="flex:1" @click="jumpTo('treatment')">
                        <img src="../assets/img/treatment_1.jpg"/>
                        <div>诊疗项目</div>
                    </div>
                    <div class="selector" style="flex:1;margin-left: 1px" @click="jumpTo('activities')">
                        <img src="../assets/img/phone_1.jpg"/>
                        <div>诊所活动</div>
                    </div>
                </div>
                <div class="space-between" style="margin-top: 1px">
                    <div class="selector" style="flex:1" @click="jumpTo('encyclopedia')">
                        <img src="../assets/img/baike_1.jpg"/>
                        <div>口腔百科</div>
                    </div>
                    <div class="selector" style="flex:1;margin-left: 1px;visibility: hidden"
                         @click="jumpTo('doctorGroup')">
                        <img src="../assets/img/v2_ptdn3q.png"/>
                        <div>医师团队</div>
                    </div>
                </div>
            </div>
        </div>

        <!--医院-->
        <template v-if="styleTemplate == 1001">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu vertical-center">
                <div class="menu-item" @click="jumpTo('introduction')">
                    <img src="../assets/img/v2_ptdn19.png"/>
                    <div>医院介绍</div>
                </div>
                <div class="menu-item" @click="jumpTo('doctorGroup')">
                    <img src="../assets/img/v2_ptdn3q.png"/>
                    <div>医师团队</div>
                </div>
                <div class="menu-item" @click="jumpTo('treatment')">
                    <img style="width:40px;height:40px;margin:5px;" src="../assets/img/v2_ptdn6e.png"/>
                    <div>诊疗项目</div>
                </div>
                <div class="menu-item" @click="jumpTo('activities')">
                    <img src="../assets/img/v2_ptdn8o.png"/>
                    <div>医院活动</div>
                </div>
                <div class="menu-item" @click="jumpTo('encyclopedia')">
                    <img src="../assets/img/v2_ptdn9p.png"/>
                    <div>口腔百科</div>
                </div>
                <div style="visibility: hidden" class="menu-item" @click="jumpTo('officeCenter')">
                    <img src="../assets/img/info_query.png"/>
                    <div>我要咨询</div>
                </div>
            </div>
        </template>
        <div class="template2" v-if="styleTemplate ==1002">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu space-between" style="background: transparent">
                <div class="menu-item" @click="jumpTo('introduction')">
                    <img src="../assets/img/v2_ptdn19.png"/>
                    <div>医院介绍</div>
                </div>
                <div class="menu-item" @click="jumpTo('doctorGroup')">
                    <img src="../assets/img/v2_ptdn3q.png"/>
                    <div>医师团队</div>
                </div>
                <div class="menu-item" @click="jumpTo('treatment')">
                    <img style="width:40px;height:40px;margin:5px;" src="../assets/img/v2_ptdn6e.png"/>
                    <div>诊疗项目</div>
                </div>
            </div>
            <div class="menu space-between" style="background: transparent">
                <div class="menu-item" @click="jumpTo('activities')">
                    <img src="../assets/img/v2_ptdn8o.png"/>
                    <div>医院活动</div>
                </div>
                <div class="menu-item" @click="jumpTo('encyclopedia')">
                    <img src="../assets/img/v2_ptdn9p.png"/>
                    <div>口腔百科</div>
                </div>
                <div style="visibility: hidden" class="menu-item" @click="jumpTo('officeCenter')">
                    <img src="../assets/img/info_query.png"/>
                    <div>我要咨询</div>
                </div>
            </div>
        </div>
        <div :class="'template'+styleTemplate" v-if="styleTemplate ==1003">
            <div style="background: white">
                <div class="swipe-style2" :style="'height:'+height+'px'" v-show="infoLoaded">
                    <mt-swipe :auto="10000">
                        <mt-swipe-item class="banner-1">
                            <img ref="img" src="../assets/img/home_bg.jpg"/>
                        </mt-swipe-item>
                        <mt-swipe-item class="banner-1">
                            <img src="../assets/img/home_bg.jpg"/>
                        </mt-swipe-item>
                    </mt-swipe>
                </div>
                <div class="menu space-between" style="background: transparent;padding: 0 10px">
                    <div class="menu-item" @click="jumpTo('introduction')">
                        <img src="../assets/img/introduction.png"/>
                        <div>医院介绍</div>
                    </div>
                    <div class="menu-item" @click="jumpTo('doctorGroup')">
                        <img src="../assets/img/persion.png"/>
                        <div>医师团队</div>
                    </div>
                    <div class="menu-item" @click="jumpTo('treatment')">
                        <img src="../assets/img/search.png"/>
                        <div>诊疗项目</div>
                    </div>
                </div>
                <div class="menu space-between" style="background: transparent;padding: 0 10px 20px 10px">
                    <div class="menu-item" @click="jumpTo('activities')">
                        <img src="../assets/img/position.png"/>
                        <div>医院活动</div>
                    </div>
                    <div class="menu-item" @click="jumpTo('encyclopedia')">
                        <img class="circle-outfield" src="../assets/img/tooth.png"/>
                        <div>口腔百科</div>
                    </div>
                    <div style="visibility: hidden" class="menu-item" @click="jumpTo('officeCenter')">
                        <img src="../assets/img/info_query.png"/>
                        <div>我要咨询</div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="'template'+styleTemplate" v-if="styleTemplate ==1004">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu">
                <div class="vertical-center">
                    <div class="padding-left-10 padding-to-10" style="width: 50%;box-sizing: border-box">
                        <div class="card-type-1" @click="jumpTo('introduction')">
                            <div class="circle-1">
                                <img style="width: 24px;height: 24px;margin-top: 9px" src="../assets/img/hospital.png"/>
                            </div>
                            <div style="color:#80e0d9;font-size: 18px;margin-top: 20px">医院介绍</div>
                        </div>
                    </div>
                    <div class="padding-left-10 padding-to-10 padding-right-10"
                         style="width: 50%;box-sizing: border-box">
                        <div>
                            <div class="card-type-2 card-color-1 vertical-center" @click="jumpTo('doctorGroup')">
                                <div class="circle-2">
                                    <img style="width: 24px;height: 24px;margin-top: 7px"
                                         src="../assets/img/doctor.png"/>
                                </div>
                                <div style="margin-left: 10px;font-size: 14px">医师团队</div>
                            </div>
                            <div class="card-type-2 card-color-2 vertical-center" @click="jumpTo('treatment')"
                                 style="margin-top: 10px">
                                <div class="circle-3">
                                    <img style="width: 20px;height: 20px;margin-top: 10px"
                                         src="../assets/img/project.png"/>
                                </div>
                                <div style="margin-left: 10px;font-size: 14px">诊疗项目</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 10px" class="vertical-center">
                    <div class="padding-left-10 padding-to-10" style="width: 50%;box-sizing: border-box">
                        <div @click="jumpTo('activities')" class="card-type-2 card-color-1 vertical-center">
                            <div class="circle-2">
                                <img style="width: 24px;height: 24px;margin-top: 7px" src="../assets/img/activity.png"/>
                            </div>
                            <div style="margin-left: 10px;font-size: 14px">医院活动</div>
                        </div>
                    </div>
                    <div class="padding-left-10 padding-to-10 padding-right-10"
                         style="width: 50%;box-sizing: border-box">
                        <div @click="jumpTo('encyclopedia')" class="card-type-2 card-color-3 vertical-center">
                            <div class="circle-1 text-center" style="width: 40px;height: 40px;">
                                <img style="width: 24px;height: 24px;margin-top: 7px;display: inline-block"
                                     src="../assets/img/tooth.png"/>
                            </div>
                            <div style="margin-left: 10px;font-size: 14px">口腔百科</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="'template'+styleTemplate" v-if="styleTemplate ==1005" style="height: 100%;background: white">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu vertical-center">
                <div class="menu-item-group" @click="jumpTo('introduction')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/doctor_2.jpg"/>
                        <div>医院介绍</div>
                    </div>
                    <img src="../assets/img/wave_1.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('doctorGroup')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/doctor_3.jpg"/>
                        <div>医师团队</div>
                    </div>
                    <img src="../assets/img/wave_2.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('treatment')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/treatment_1.jpg"/>
                        <div>诊疗项目</div>
                    </div>
                    <img src="../assets/img/wave_2.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('activities')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/phone_1.jpg"/>
                        <div>医院活动</div>
                    </div>
                    <img src="../assets/img/wave_1.jpg"/>
                </div>

                <div class="menu-item-group" @click="jumpTo('encyclopedia')">
                    <div class="menu-item vertical-center">
                        <img src="../assets/img/baike_1.jpg"/>
                        <div>口腔百科</div>
                    </div>
                    <img src="../assets/img/wave_1.jpg"/>
                </div>
            </div>
        </div>

        <div :class="'template'+styleTemplate" v-if="styleTemplate ==1006" style="height: 100%">
            <div :style="'height:'+height+'px'" v-show="infoLoaded">
                <mt-swipe :auto="4000">
                    <mt-swipe-item v-for="item,index in banner" class="banner-1">
                        <img :ref="index?'img' + index:'img'" :src="item" onerror="this.src = defaultBg"/>
                    </mt-swipe-item>
                </mt-swipe>
            </div>
            <div class="menu border-layout-bottom" :style="'top:'+height+'px;margin-top:6px;background:transparent'">
                <div class="space-between">
                    <div class="selector" style="flex:1" @click="jumpTo('introduction')">
                        <img src="../assets/img/doctor_2.jpg"/>
                        <div>医院介绍</div>
                    </div>
                    <div class="selector" style="flex:1;margin-left: 1px" @click="jumpTo('doctorGroup')">
                        <img src="../assets/img/doctor_3.jpg"/>
                        <div>医师团队</div>
                    </div>
                </div>
                <div class="space-between" style="margin-top: 1px">
                    <div class="selector" style="flex:1" @click="jumpTo('treatment')">
                        <img src="../assets/img/treatment_1.jpg"/>
                        <div>诊疗项目</div>
                    </div>
                    <div class="selector" style="flex:1;margin-left: 1px" @click="jumpTo('activities')">
                        <img src="../assets/img/phone_1.jpg"/>
                        <div>医院活动</div>
                    </div>
                </div>
                <div class="space-between" style="margin-top: 1px">
                    <div class="selector" style="flex:1" @click="jumpTo('encyclopedia')">
                        <img src="../assets/img/baike_1.jpg"/>
                        <div>口腔百科</div>
                    </div>
                    <div class="selector" style="flex:1;margin-left: 1px;visibility: hidden"
                         @click="jumpTo('doctorGroup')">
                        <img src="../assets/img/v2_ptdn3q.png"/>
                        <div>医师团队</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast} from 'mint-ui';
    import defaultBg from "../assets/img/home_bg.jpg";

    export default {
        data() {
            return {
                defaultBg:defaultBg,
                banner:[defaultBg],
                authed: false,
                appid: "",
                code: "",
                openId: '',
                appidAgent: "",
                location: location,
                height: 220,
                YY_USER_ID: "",
                infoLoaded: 0,
                imageLoaded: 0,
                styleTemplate: 4
            }
        },
        methods: {
            loadTop: function () {
                let _this = this;
                setTimeout(() => {
                    _this.$refs.loadmore.onTopLoaded();
                }, 1000)
            },
            loadBottom: function () {
                let _this = this;
                setTimeout(() => {
                    this.allLoaded = true;// if all data are loaded
                    this.$refs.loadmore.onBottomLoaded();
                }, 1000)
            },
            auth: function () {
                Indicator.open('加载中...');
                const scope = 'snsapi_userinfo'; // snsapi_base|snsapi_userinfo
                api.getFormUrl(this, "/yy/front/getWxAppid", null, (res) => {
                    console.log(res);
                    this.appid = res.appId;
                    this.appidAgent = res.componetAppId;
                    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.appid 
                            + "&redirect_uri=" + encodeURIComponent(window.location.href) 
                            + `&response_type=code&scope=${scope}&state=STATE&component_appid=` + this.appidAgent + "#wechat_redirect";
                    // alert(url)
                    window.location.href = url;
                }, (err) => {
                    Toast({
                        message: err.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                    Indicator.close();
                });
            },
            jumpTo: function (path) {
                this.$router.push({
                    path: path,
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
            }
        },
        mounted() {
            let _this = this;

            window._this = this;
            Indicator.open('加载中...');

            this.infoLoaded = true;

            this.$refs.img.onload = function () {
                console.log(this.$refs.img);
                _this.height = _this.$refs.img.height;
                _this.imageLoaded = 1;
                setTimeout(() => {
                    // _this.$refs.page.style.opacity = _this.imageLoaded * _this.infoLoaded;
                    Indicator.close();
                }, 300);
            }
            this.$refs.img.onerror = function () {
                _this.imageLoaded = 1;
                // _this.$refs.page.style.opacity = _this.imageLoaded * _this.infoLoaded;
                Indicator.close();
            }

        },
        created() {
            this.code = utils.getUrlParam2("code");
            this.authed = !!this.code;

            if (!this.authed) {   //没有微信授权时
                this.auth();
            } else {
                if (!this.$route.query.openId) {
                    this.appid = utils.getUrlParam2("appid");
                    api.getFormUrl(this, "/yy/front/getOpenIdByCode?appId=" + this.appid + "&code=" + this.code, null, (res) => {
                        // alert(JSON.stringify(res))
                        console.log(res);
                        this.openid = res.openId;
                        location.href = location.href + "&openId=" + res.openId;
                    }, (err) => {
                        Toast({
                            message: "获取openid失败" + err.rspDesc,
                            position: 'bottom',
                            duration: 5000
                        });
                        Indicator.close();
                    });
                }
                api.getFormUrl(this, "/yy/front/getBaseInfo", null, (res) => {
                    if(res.backImgUrl){
                        _this.banner = res.backImgUrl.split(",");
                    }
                    _this.styleTemplate = res.webSiteTemplateId;
                    _this.infoLoaded = 1;
                    _this.$refs.page.style.opacity = 1;
                    document.getElementsByTagName("title")[0].innerText = res.name || "";
                    Indicator.close();

                    // setTimeout(() => {
                    //     _this.$refs.page.style.opacity = _this.imageLoaded * _this.infoLoaded;
                    // }, 300);
                }, (err) => {
                    Toast({
                        message: err.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                    Indicator.close();
                });
            }
        }
    };
</script>

<style lang="scss">
    @import "../assets/styles/common.css";

    .banner-1 > img {
        width: 100%;
    }

    .menu {
        background: white;
        margin-top: 10px;
    }

    .menu-item {
        width: 33%;
        padding: 15px 0 15px 0;
        text-align: center;
    }

    .menu-item > img {
        width: 50px;
        height: 50px;
        margin: auto;
    }

    .menu-item > div {
        width: 100%;
        text-align: center;
    }

    .template2 {
        .menu {
            margin: 10px 10px 0 10px;
            .menu-item {
                background: white;
                width: 31%;
            }
        }
    }

    .swipe-style2 {
        padding-bottom: 20px;
        .mint-swipe {
            /*width: 80%;*/
        }
        .mint-swipe-item {
            padding: 15px 20px;
            box-sizing: border-box;
            img {
                overflow: hidden;
                border-radius: 10px;
                box-shadow: 1px 1px 8px rgba(22, 122, 224, 0.3);
                width: auto;
                height: auto;
            }
        }
    }

    .template3,.template1003 {
        .circle-outfield {
            background: #1ec2d5;
            border-radius: 100px;
            padding: 10px;
            width: 45px;
            height: 45px;
            box-sizing: border-box;
            box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
        }

        .menu-item {
            color: #707070;
        }
    }

    .template4,.template1004 {
        .menu {
            background: transparent;
            .padding-left-10 {
                padding-left: 10px;
            }
            .padding-top-10 {
                padding-top: 10px;
            }
            .padding-right-10 {
                padding-right: 10px;
            }
            .card-type-1 {
                width: 100%;
                height: 170px;
                box-sizing: border-box;
                background: #d4f7f3;
                text-align: center;
                padding: 20px 0 30px 0;
                color: #80e0d9;
                border-radius: 6px;
            }

            .card-type-2 {
                width: 100%;
                height: 80px;
                border-radius: 6px;
                box-sizing: border-box;
                padding: 19px 15px;
            }

            .card-color-1 {
                background: #e5dbf4;
                color: #a473df;
            }
            .card-color-2 {
                background: #f8eae1;
                color: #f4a671;
            }

            .circle-1 {
                width: 46px;
                height: 46px;
                display: inline-block;
                border-radius: 100px;
                background: #80e0d9;
            }
            .circle-2 {
                img {
                    display: inline-block;
                }
                width: 40px;
                height: 40px;
                text-align: center;
                border-radius: 100px;
                background: #a473df;
            }
            .circle-3 {
                img {
                    display: inline-block;
                }
                width: 40px;
                height: 40px;
                text-align: center;
                border-radius: 100px;
                background: #f4a671;
            }

            .card-color-3 {
                background: #d4f7f3;
                color: #80e0d9;
            }
        }
    }

    .template5,.template1005 {
        .menu-item-group {
            width: 50%;
            height: 95px;
            & > img {
                width: 70%;
                margin-left: 16%;
            }
        }
        .menu-item {
            width: 100%;
            padding-bottom: 4px;
            & > img {
                width: 52px;
            }
            div {
                width: auto;
                font-size: 16px;
                color: #555555;
                margin-left: 10px;
            }
        }
    }

    .template6,.template1006 {
        .selector {
            background: white;
            padding: 20px 0;
            &:active {
                background: transparent;
            }
            img {
                width: 50px;
                height: 50px;
            }
            font-size: 16px;
            color: #666;
            text-align: center;
        }
    }
</style>
